import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import {
  DeleteCustomerContactMutation as _DeleteCustomerAddressMutation,
  DeleteCustomerContactInput,
} from '@/gql/graphql';

const DeleteCustomerContactMutation = graphql(`
  mutation DeleteCustomerContact($input: DeleteCustomerContactInput!) {
    deleteCustomerContact(input: $input) {
      id
    }
  }
`);

const useDeleteCustomerContact = (
  options?: UseMutationOptions<
    _DeleteCustomerAddressMutation,
    unknown,
    DeleteCustomerContactInput
  >
) => {
  return useMutation({
    mutationFn: (input) => {
      return gqlClient.request(DeleteCustomerContactMutation, {
        input,
      });
    },
    ...options,
  });
};

export default useDeleteCustomerContact;
